module.exports = __webpack_public_path__ + "img/1.f7f8a47a.png";